// 仓库承运商账户
import TableList from "@components/templates/tablelist";
import compUpload from "@components/templates/selectupload";
import { HttpGetAbnormal } from "@/service/billing";

import { mapGetters } from "vuex";

import comUnfreeze from './alertunfreeze'

export default {
    mixins: [TableList],
    components:{
        comUnfreeze,
        compUpload
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_errorType: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetAbnormal,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "unfreeze":
                    this.operate = {
                        title: this.$t('fbb.bill.unfreez',{defaultValue:'单据解冻'}),
                        show:true,
                        width:500,
                        component: "comUnfreeze",
                        showFooter:false
                    }
                    break;
                case "allunfreeze":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data',{defaultValue:'导入数据'}),
                        width: 460,
                        showFooter: false,
                        name: "file",
                        component: "compUpload",
                        localurl:true,
                        actionurl:process.env.VUE_APP_APIURL_FBB + "/api/v2/funding/unfreeze/upload",
                        downrul:'/static/template/allunfreeze.xlsx',
                        // formdata: [
                        //     {
                        //         label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                        //         key: "billMonth",
                        //         tag: 'vDatepicker',
                        //         props: {
                        //             format: 'yyyy-mm',
                        //             confirm: false,
                        //         },
                        //         labelWidth: 90,
                        //         span:24,
                        //     },
                        //     {
                        //         label: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                        //         key: "billNo",
                        //         required:false,
                        //         labelWidth: 90,
                        //         span:24,
                        //     },
                        // ],
                    };
                    break;
                case 'exportExcel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/funding/unfreeze/export', this.formData, 'download');
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary',['getNextOrgList','getCarrierAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('fbb.bill.unfreez',{defaultValue:'单据解冻'}),
                    operate: "unfreeze",
                    theme: "primary",
                },
                {
                    label: this.$t('fbb.bill.batchunfreez',{defaultValue:'批量解冻'}),
                    operate: "allunfreeze",
                    theme: "success",
                },
                {
                    label: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "exportExcel",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization',{defaultValue:'组织'}),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options: this.getNextOrgList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                
                {
                    label: this.$t('fbb.bill.freeze_trackingno',{defaultValue:'运单号'}),
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,

                },
                {
                    label: this.$t('fbb.bill.freeze_open',{defaultValue:'解冻'})+this.$t('fbb.alloment.date',{defaultValue:'日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    key: "EQ_billMonth",
                    tag: 'vDatepicker',
                    props: {
                        format: 'yyyy-mm',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    tag: 'vInput',
                    key: "EQ_billNo",
                },

            ]
        },
        columns() {
            return [
            {
                title: this.$t('fbb.bill.account_org',{defaultValue:'账户组织'}),
                key: 'organizationName',
                
            },
            {
                title: this.$t('fbb.bill.delamount',{defaultValue:'扣款金额'})+'(USD)',
                key: 'amount',
            },
            {
                title: this.$t('global.common.order_no',{defaultValue:'单号'}),
                key: 'trackingNo',
            },
            {
                title: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                key: 'billMonth',
            },
            {
                title: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                key: 'billNo',
            },
            {
                title: this.$t('fbb.bill.freeze_open',{defaultValue:'解冻'})+this.$t('global.datepicker.time',{defaultValue:'时间'}),
                key: 'createdAt',
                sortable: true
            },
            {
                title: this.$t('fbb.bill.freeze_open',{defaultValue:'解冻'})+this.$t('global.common.reason',{defaultValue:'原因'}),
                key: 'cause',
            },
            {
                title: this.$t('global.common.operator',{defaultValue:'操作人'}),
                key: 'createdName',
            },
            ];
        },

    },

};
